module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_num"
  }, [_vm._v("Appendix E")]), _vm._v(" "), _c('h2', {
    staticClass: "chap_title"
  }, [_vm._v("The Composition and Command Cadre of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v("  of the Mozhaisk Defense Line, 18 July 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FRONT")]), _vm._v("  OF THE MOZHAISK DEFENSE LINE")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Lieutenant General of NKVD Troops Pavel Artem’evich Artem’ev, chief of the NKVD’s Operations Directorate and commander of the Moscow Military District")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commissar")]), _vm._v(" – I. M. Sokolov")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief of Staff")]), _vm._v(" – Major General A. I. Kudriashev")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Occupy the Kushelevo, Iaropolets, Koloch’ Station, Il’inskoe, and Detchino line and prepare for a firm defense.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("32nd Army")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander –")]), _vm._v(" Lieutenant General Nikolai Kuz’mich Klykov, former deputy commander of the Moscow Military District for Training")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Member of the Military Council")]), _vm._v(" – G. N. Zhilenkov")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief of Staff")]), _vm._v(" – Colonel I. A. Kuzokov")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(" – five rifle divisions, including one NKVD and four peoples’ militia divisions, one RGK artillery regiment, and three antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Firmly defend the Kushelevo, Iaropolets, Chubarovo, and Karacharovo line. Pay special attention to organizing defense of the Rzhev-Volokolamsk and Sychevka-Volokolamsk axes.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Boundary on the left")]), _vm._v(" – (incl.) Savinki, Tarkhanovo, and Pavlovskaia Sloboda.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Volokolamsk")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("33rd Army")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander –")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kombrig")]), _vm._v(" (Brigade commander) Dmitri Platonovich Onuprienko, former deputy chief of the NKVD’s Directorate for Operational Forces and chief of staff of the Moscow Military District")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Member of the Military Council")]), _vm._v(" – M. D. Shliakhtin")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief of Staff")]), _vm._v(" – Lieutenant Colonel I. K. Prostov")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(" – five rifle divisions, including three NKVD divisions and two peoples’ militia divisions, one tank division (109th), one RGK artillery regiment, and three antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Firmly defend the Glazovo, Koloch Station, and Sosnovtsy line. Pay special attention to organizing defenses along the Gzhatsk-Mozhaisk-Kubinka axis.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("34th Army")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kombrig")]), _vm._v(" Nikolai Nilovich Pronin, former chief of the Command Faculty at the Frunze Academy and commander of 1st Moscow Rifle Division")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Member of the Military Council")]), _vm._v(" – I. P. Voinov")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief of Staff")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kombrig")]), _vm._v(" A. G. Galkin")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(" – five rifle divisions, including one NKVD division and four peoples’ militia divisions, one RGK artillery regiment, and three antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Firmly defend the Nikitskoe, Red’kino, and Nozdrino line. Pay special attention to organizing defenses along the Iukhnov-Medyn’-Maloiaroslavets axis.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Maloiaroslavets")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Note")]), _vm._v(" – Soon after, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stavka")]), _vm._v(" also created a new 35th Army under the Front of Reserve Armies. After the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stavka")]), _vm._v(" renumbered 35th Army as 49th Army, it formed a new 35th Army in the Far East.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Source")]), _vm._v(": “Prikaz Stavki VK No. 00409 o formirovanii fronta Mozhaiskoi linii oborony [Stavka VK order no. 00409 about the formation of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v(" of the Mozhaisk line of defense], in Zolotarev, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stavka")]), _vm._v(" 1941,” 77-78.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e91526","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/15_Chapter_5.vue
// module id = 102
// module chunks = 0